// tools
import { Status } from "tools/Enums";

// components
import { dropDownOptions } from "components/DropDownMenu";

export default class GetStatus {
	static getName(status) {
		switch (status) {
			case Status.Open:
				return "Open";
			case Status.UnderReview:
				return "Under Review";
			case Status.Planned:
				return "Planned";
			case Status.InProgress:
				return "In progress";
			case Status.Live:
				return "Live";
			case Status.Closed:
				return "Closed";
		}
	}

	static getDropDownItem(status) {
		switch (status) {
			case Status.Open:
				return new dropDownOptions(GetStatus.getName(Status.Open), "", "grey", Status.Open);
			case Status.UnderReview:
				return new dropDownOptions(GetStatus.getName(Status.UnderReview), "", "dark-grey", Status.UnderReview);
			case Status.Planned:
				return new dropDownOptions(GetStatus.getName(Status.Planned), "", "blue", Status.Planned);
			case Status.InProgress:
				return new dropDownOptions(GetStatus.getName(Status.InProgress), "", "yellow", Status.InProgress);
			case Status.Live:
				return new dropDownOptions(GetStatus.getName(Status.Live), "", "green", Status.Live);
			case Status.Closed:
				return new dropDownOptions(GetStatus.getName(Status.Closed), "", "red", Status.Closed);
		}
	}
}
export const dropDownStatusOptionsArray = [
	GetStatus.getDropDownItem(Status.Open),
	GetStatus.getDropDownItem(Status.UnderReview),
	GetStatus.getDropDownItem(Status.Planned),
	GetStatus.getDropDownItem(Status.InProgress),
	GetStatus.getDropDownItem(Status.Live),
	GetStatus.getDropDownItem(Status.Closed),
];
